import { StoreTypes } from '../../src/util/types';

export const selectedChangeForEdit = (state = { selectedChange: null }, action) => {
    switch (action.type) {
        case StoreTypes.SAVE_SELECTED_CHANGE:
            return { ...state, selectedChange: action.payload }
        default:
            return state;
    }
}